import {
  type FleetSwitchableArea,
  type PermissionCode as PermissionCodeType,
} from '@gb-ticket/shared-types';
import { Loader2Icon } from 'lucide-react';
import { Navigate, Outlet } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { fleetAreaOn, useFleetAreas } from '@/products/fleet/features/use-fleet-areas';
import { FLEET_ROOT } from '@/products/fleet/fleet-paths';

function Pending() {
  return (
    <p className="flex items-center gap-2 text-muted-foreground">
      <Loader2Icon className="size-4 animate-spin" aria-hidden />
      Wird geladen …
    </p>
  );
}

function permissionList(
  permission: PermissionCodeType | readonly PermissionCodeType[] | undefined,
): readonly PermissionCodeType[] {
  if (permission === undefined) {
    return [];
  }
  if (typeof permission === 'string') {
    return [permission];
  }
  return permission;
}

/** Sends a direct URL of a disabled area back to the fleet home. */
export function FleetAreaGate({
  anyOf,
  permission,
}: {
  anyOf: readonly FleetSwitchableArea[];
  permission?: PermissionCodeType | readonly PermissionCodeType[];
}) {
  const me = useMe();
  const areas = useFleetAreas();
  if (me.isPending || areas.isPending) {
    return <Pending />;
  }
  const permissions = permissionList(permission);
  const permissionOk =
    permissions.length === 0 || permissions.some((code) => hasPermission(me.data, code));
  const catalog = areas.isError ? undefined : areas.data;
  const areaOk = anyOf.some((code) => fleetAreaOn(catalog, code));
  if (!permissionOk || !areaOk) {
    return <Navigate to={FLEET_ROOT} replace />;
  }
  return <Outlet />;
}
